/**
 * Campaign countdown on cwp/casino-toplist: ticks the timers the server
 * printed ([data-cwp-countdown]: Casino\Countdown::render beside the title,
 * Countdown::strip on the sticky bar, Countdown::topStrip pinned above the
 * header) by the visitor's clock. Anonymous pages sit in a 10-minute page
 * cache, so only the browser knows whether the campaign has started or ended:
 * it shows a timer from its start, counts it down, and hides it at its end.
 *
 * Reads data-start (ISO 8601, or "" for no start) and data-end (ISO 8601);
 * writes the numbers into the [data-unit="d|h|m|s"] spans.
 */

/** 'before' the start, 'running', or 'ended' (from the end instant). A null start means no start. */
export function countdownPhase(startMs, endMs, nowMs) {
	// !(<) rather than >=, so an end that did not parse (NaN) counts as ended
	// and the timer hides instead of printing NaN.
	if (!(nowMs < endMs)) return 'ended';
	return startMs !== null && nowMs < startMs ? 'before' : 'running';
}

/** Whole seconds left until endMs as days, hours, minutes and seconds; zeros once it has passed. */
export function countdownParts(endMs, nowMs) {
	const left = Math.max(0, Math.floor((endMs - nowMs) / 1000));
	return {
		d: Math.floor(left / 86400),
		h: Math.floor(left / 3600) % 24,
		m: Math.floor(left / 60) % 60,
		s: left % 60,
	};
}

/** A number as all three timers print it (as the server does): days as they are, the rest in two digits, "6" and "05". */
export function countdownDigits(unit, n) {
	return unit === 'd' ? String(n) : String(n).padStart(2, '0');
}

export const cwpCountdown = {
	init() {
		document.querySelectorAll('[data-cwp-countdown]').forEach((el) => {
			const from = Date.parse(el.dataset.start);
			const start = Number.isNaN(from) ? null : from;
			const end = Date.parse(el.dataset.end);
			const numbers = el.querySelectorAll('[data-unit]');

			const tick = () => {
				const now = Date.now();
				const phase = countdownPhase(start, end, now);
				const hide = phase !== 'running';
				// Only a change is written: before the start every tick would set hidden again, and each write is a mutation.
				if (el.hidden !== hide) el.hidden = hide;

				if (phase === 'running') {
					const parts = countdownParts(end, now);
					numbers.forEach((n) => {
						n.textContent = countdownDigits(n.dataset.unit, parts[n.dataset.unit]);
					});
				}

				// Every tick reads the clock afresh, so a tab that slept catches up.
				// Aim at the next whole second, not 1000 ms from now, so the
				// display does not drift.
				if (phase !== 'ended') setTimeout(tick, 1000 - (Date.now() % 1000));
			};

			tick();
		});
	},
};
